(function () {
  'use strict';

  angular.module('sempraWebapp')
    .directive('averageMoneyByHourChart', averageMoneyByHourChartDirective)
    .controller('averageMoneyByHourChartController', averageMoneyByHourChartController);

  /** @ngInject */
  function averageMoneyByHourChartDirective ($timeout) {
    return {
      restrict: 'E',
      scope: {},
      templateUrl: 'app/components/averageMoneyByHourChart/averageMoneyByHourChart.html',
      controller: 'averageMoneyByHourChartController',
      controllerAs: 'vm',
      link: function (scope) {
        $timeout(scope.vm.initChart, 100);
      }
    };
  }

  /** @ngInject */
  function averageMoneyByHourChartController ($scope) {
    var vm = this;

    vm.chart = null;
    vm.chartElementId = 'averageMoneyByHourChart';
    vm.data = null;
    vm.initChart = createChart;

    init();

    function init () {
      $scope.$on('$destroy', destroy);
    }

    function destroy () {
      if (vm.chart) {
        vm.chart.destroy();
      }
    }

    function createChart () {
      vm.chart = c3.generate({
        bindto: '#' + vm.chartElementId,
        data: {
          x: 'x',
          columns: [
            ['x', 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23],
            ['Subotica', 30, 200, 100, 400, 150, 250, 30, 200, 100, 400, 150, 250, 30, 200, 100, 400, 150, 250, 150, 250, 30, 200, 100, 400, 150, 250],
            ['Zrenjanin', 130, 300, 200, 300, 250, 450, 130, 300, 200, 300, 250, 450, 130, 300, 200, 300, 250, 450, 130, 300, 200, 300, 250, 450],
            ['Beograd', 100, 250, 150, 200, 100, 350, 100, 250, 150, 200, 100, 350, 100, 250, 150, 200, 100, 350, 100, 250, 150, 200, 100, 350]
          ]
        }
      });
    }

  }
})();
